const rootPage = {
  en: {
    placeholder: {
      title: 'Welcome to TemboHealth',
      caption: 'To get started select a section in the left bar',
    },
    filters: {
      title: 'All filters',
      allFiltersBtn: 'All filters',
      clearBtn: 'Clear filters',
      applyBtn: 'Apply filters',
    },
  },
}
export default rootPage
